/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import {
  MaterialInspectionTableModelInitValues,
  MaterialInspectionModel,
} from '../models/MaterialInspectionModel'
import * as MaterialInspectionAction from '../redux/MaterialInspectionAction'

interface Props {
  show: boolean
  handleClose: () => void
  materialInspection: MaterialInspectionModel
}

export const MaterialInspectionDeleteConfirmModal: FC<Props> = ({
  show,
  handleClose,
  materialInspection,
}) => {
  const [loading, setLoading] = useState(false)
  let navigate = useNavigate()
  const dispatch: any = useDispatch()

  const deleteMaterialInspection = () => {
    setLoading(true)
    dispatch(
      MaterialInspectionAction.remove(
        materialInspection?._id,
        MaterialInspectionTableModelInitValues
      )
    )
      .then((response: any) => {
        toast.success(response)
        setLoading(false)
        navigate('/material-inspection')
      })
      .catch((error: any) => {
        toast.error(error)
        setLoading(false)
      })
    handleClose()
  }

  return (
    <>
      <Modal
        id='kt_modal_delete_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-500px h-auto'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h2>Delete Material Inspection</h2>
          </div>

          <div className='modal-body flex-row-fluid py-lg-10 px-lg-10'>
            <p className='d-flex align-items-center fs-5 fw-bold'>
              Are you sure you want to delete this material inspection ({materialInspection?.number}
              )?
            </p>
            <div className='d-flex flex-stack mt-5'>
              <button
                type='button'
                className='btn btn-lg btn-light-primary float-left'
                onClick={() => {
                  handleClose()
                }}
              >
                Cancel
              </button>
              <button
                type='submit'
                className='btn btn-lg btn-primary float-right'
                onClick={() => {
                  deleteMaterialInspection()
                }}
                disabled={loading}
              >
                <span className='indicator-label'>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
